export const ROYAL_BLUE = "#425af2";
export const TROPICAL_BLUE = "#B8C2F8";
export const SELAGO = "#F3F4FE";
export const ORANGE_RED = "#FF5656";
export const RED = "#d1222c";
export const MINT_GREEN = "#22D9A2";
export const GREEN = "#209d7f";
export const LIGHTER_GRAY = "#F9F9F9";
export const LIGHT_GRAY = "#D7D7D7";
export const MEDIUM_GRAY = "#C5C5C5";
export const DARK_GRAY = "#939393";
export const DARKISH_GRAY = "#515151";
export const DARKER_GRAY = "#282828";
export const WHITE = "#ffffff";
export const OFF_WHITE = "#fbfbfd";
export const BLACK = "#000000";
export const GRAY = "#f6f7fb";
export const LIGHTER_BLACK = "#1e1e1e";
export const GHOST_WHITE = "#f5f5f9";
